import { LOGIN_STORAGE_KEY } from 'New/login/utils/constants'

export enum LoginStorageValues {
  AUTH_LOGIN = "0",
  ACCOUNT_LOGIN = "1",
  MOBILE_CODE_LOGIN = "2",
}

let handleStorage: ((event: StorageEvent) => void) | null

export const removeStorageListener = () => {
  if (handleStorage) {
    window.removeEventListener("storage", handleStorage)
    handleStorage = null
  }
}

export const watchLoginByStorage = (storageValue: LoginStorageValues, success: () => void) => {
  removeStorageListener()

  localStorage.setItem(LOGIN_STORAGE_KEY, storageValue)

  handleStorage = (event: StorageEvent) => {
    if (event.key === LOGIN_STORAGE_KEY && event.oldValue === storageValue) {
      localStorage.setItem(LOGIN_STORAGE_KEY, event.oldValue) // 刷新之后取值
      success()
    }
  }
  window.addEventListener("storage", handleStorage)
}